import { useMutation } from "@tanstack/react-query";
import { authEndpoints } from "@src/services/endpoints";

const AuthHooks = {
  useSignup: (requiredEmail, callback, onError) =>
    useMutation({
      mutationFn: async (data) => {
        // Fail open: if the status can't be fetched, let identity decide
        const customerStatus = data.customerCode
          ? await authEndpoints
              .getCustomerStatus(data.customerCode)
              .catch((error) => {
                console.error("Could not check customer status", error);
                return null;
              })
          : null;
        if (customerStatus?.contractEnded) {
          throw new Error(
            `${customerStatus.customerName}'s Signol subscription is no longer active. If you believe this is an error or would like to restore access, please reach out to your manager.`,
          );
        }
        if (requiredEmail) {
          const res = await authEndpoints.verifyEmailAddressInCustomer(
            data.username,
            data.customerCode,
            true,
          );
          if (!res) {
            throw new Error(
              "The email address provided is shared with other colleagues. Please try using a personal one.",
            );
          }
        }
        return authEndpoints.signup(data);
      },
      onSuccess: callback,
      onError,
    }),

  useChangePassword: (callback) =>
    useMutation({
      mutationFn: (inputData) => authEndpoints.requestChangePassword(inputData),
      onSuccess: (data) => {
        console.log("New password saved successfully", data);
        // handle success, e.g., show a toast or update state
        if (callback) {
          callback(true);
        }
      },
      onError: (error, variables, context) => {
        console.error("Error saving new password", error);
        if (callback) {
          callback(false);
        }
        // trackError(error, "useChangePassword", { variables, context });
        // handle error, e.g., show an error message
      },
    }),
};

export default AuthHooks;
